import { useAuthStore } from '@stores/authStore';

/**
 * Menú y rutas con `requireProfitabilityAccess`:
 * - tenant_external: `profitability.enabled` en su equipo.
 * - tenant_3pl: solo si el backend marca que algún hijo tiene el módulo
 *   (`profitability.children_enabled` u homónimos; fallback `profitability.enabled` en el padre).
 */
export const useProfitabilityAccess = (): boolean => {
  return useAuthStore((s) => s.getProfitabilityMenuVisible());
};
